import { useParams } from 'react-router-dom';
import queries from '@nc-aftermarket/config/queryDefs';
import { SaleTableColumnSets } from '../components/SaleTable.columns';
import SaleTablePage from '../components/SaleTablePage';

export default function Collection() {
  const params = useParams();
  return (
    <SaleTablePage
      query={queries.CollectionTable}
      queryVars={{ collectionId: params.slug }}
      salesPath="collection.sales"
      showAddToCart={data => data?.collection?.saleType === 'buy'}
      showWatch={data => data?.collection?.saleType === 'auction'}
      visibleColumns={data =>
        data?.collection?.saleType === 'auction'
          ? SaleTableColumnSets.auction
          : SaleTableColumnSets.buynow
      }
    />
  );
}
